// extracted by mini-css-extract-plugin
export default {"wrapper":"note_wrapper__iS91G","note":"note_note__7mF+p"};